(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["calculadora-pijamas"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('cosmic-order-calculator')) {
  customElements.define('cosmic-order-calculator', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      const config = JSON.parse(
        this.querySelector('[data-calculator-config]').textContent
      );

      const section = this;

      if (!section.querySelector('[data-selected-products]')) return;

      const selectedProductsContainer = section.querySelector('[data-selected-products]');
      const emptyState = section.querySelector('[data-empty-state]');
      const totalsWrapper = section.querySelector('[data-totals]');
      const totalUnitsEl = section.querySelector('[data-total-units]');
      const subtotalEl = section.querySelector('[data-subtotal]');
      const discountLabelEl = section.querySelector('[data-discount-label]');
      const discountPercentEl = section.querySelector('[data-discount-percent]');
      const savingsEl = section.querySelector('[data-savings]');
      const estimatedTotalEl = section.querySelector('[data-estimated-total]');
      const addToCartButton = section.querySelector('[data-add-to-cart]');
      const messageEl = section.querySelector('[data-message]');

      const discountProgress = section.querySelector('[data-discount-progress]');
      const progressMessage = section.querySelector('[data-progress-message]');
      const progressTrack = section.querySelector('[data-progress-track]');
      const progressFill = section.querySelector('[data-progress-fill]');
      const progressBadge = section.querySelector('[data-progress-badge]');

      const selectedProducts = {};
      const currency = config.currency;
      const locale = config.locale;

      const discountTiers = config.discountTiers
        .filter(tier =>
          Number.isFinite(Number(tier.minQty)) &&
          Number(tier.minQty) > 0 &&
          Number.isFinite(Number(tier.discount)) &&
          Number(tier.discount) >= 0
        )
        .sort((a, b) => a.minQty - b.minQty);

      function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text || '';

        return div.innerHTML
          .replaceAll('"', '&quot;')
          .replaceAll("'", '&#39;');
      }

      function formatMoney(cents) {
        const value = Number(cents || 0) / 100;

        try {
          return new Intl.NumberFormat(locale || 'es-CO', {
            style: 'currency',
            currency: currency || 'COP'
          }).format(value);
        } catch (error) {
          return '$ ' + value.toFixed(2);
        }
      }

      function getApplicableTier(totalQty) {
        let applicableTier = {
          minQty: 0,
          discount: 0,
          label: config.discount_label
        };

        discountTiers.forEach(function (tier) {
          if (totalQty >= Number(tier.minQty)) {
            applicableTier = tier;
          }
        });

        return applicableTier;
      }

      function setMessage(text) {
        if (!messageEl) return;

        messageEl.textContent = text || '';

        if (text) {
          window.clearTimeout(setMessage.timeout);

          setMessage.timeout = window.setTimeout(function () {
            messageEl.textContent = '';
          }, 4000);
        }
      }

      function getTotals() {
        let totalQty = 0;
        let subtotal = 0;

        Object.keys(selectedProducts).forEach(function (variantId) {
          const item = selectedProducts[variantId];

          totalQty += item.quantity;
          subtotal += item.quantity * item.price;
        });

        const tier = getApplicableTier(totalQty);

        const savings = Math.min(
          subtotal,
          Math.max(0, Math.round(Number(tier.discount) || 0))
        );

        const estimatedTotal = subtotal - savings;

        return {
          totalQty: totalQty,
          subtotal: subtotal,
          tier: tier,
          savings: savings,
          estimatedTotal: estimatedTotal
        };
      }

      function updateDiscountProgress(totals) {
        if (
          !discountProgress ||
          !progressMessage ||
          !progressTrack ||
          !progressFill ||
          !progressBadge
        ) return;

        const currentDiscount = Number(totals.tier.discount) || 0;

        const nextTier = discountTiers.find(function (tier) {
          const minimum = Number(tier.minQty);

          return minimum > totals.totalQty &&
            Number(getApplicableTier(minimum).discount) > currentDiscount;
        });

        const activeTier = nextTier || totals.tier;

        if (!nextTier && currentDiscount <= 0) {
          discountProgress.hidden = true;
          return;
        }

        const targetQty = Number(activeTier.minQty) || 0;

        const remaining = Math.max(
          0,
          Math.ceil(targetQty - totals.totalQty)
        );

        const displayDiscount = nextTier
          ? Number(activeTier.discount)
          : totals.savings;

        const progress = nextTier
          ? Math.max(
              0,
              Math.min(100, totals.totalQty / targetQty * 100)
            )
          : 100;

        function personalize(template) {
          return String(template || '')
            .split('{faltan}').join(String(remaining))
            .split('{cantidad}').join(String(targetQty))
            .split('{descuento}').join(formatMoney(displayDiscount));
        }

        const fallbackBefore = remaining === 1
          ? 'Agrega 1 pijama más para obtener {descuento} de descuento estimado.'
          : 'Agrega {faltan} pijamas más para obtener {descuento} de descuento estimado.';

        const fallbackReached =
          'Tu descuento estimado es de {descuento}.';

        const messageTemplate = nextTier
          ? activeTier.progress_before || fallbackBefore
          : activeTier.progress_reached || fallbackReached;

        const message = personalize(messageTemplate);

        const badge = personalize(
          activeTier.badge_text || '{descuento}'
        );

        discountProgress.hidden = false;
        progressMessage.textContent = message;
        progressBadge.textContent = badge;
        progressFill.style.width = progress + '%';

        progressTrack.setAttribute(
          'aria-valuenow',
          String(Math.round(progress))
        );

        progressTrack.setAttribute(
          'aria-valuetext',
          nextTier
            ? totals.totalQty + ' de ' + targetQty + ' pijamas. ' + message
            : message
        );
      }

      function updateTotals() {
        const totals = getTotals();

        updateDiscountProgress(totals);

        totalUnitsEl.textContent = totals.totalQty;
        subtotalEl.textContent = formatMoney(totals.subtotal);
        discountLabelEl.textContent =
          totals.tier.label || config.discount_label;
        discountPercentEl.textContent =
          '-' + formatMoney(totals.savings);
        savingsEl.textContent = formatMoney(totals.savings);
        estimatedTotalEl.textContent = formatMoney(totals.estimatedTotal);
      }

      function renderSelectedProducts() {
        const variantIds = Object.keys(selectedProducts);
        selectedProductsContainer.innerHTML = '';

        if (variantIds.length === 0) {
          emptyState.hidden = false;
          totalsWrapper.hidden = true;
          addToCartButton.disabled = true;
          updateTotals();
          return;
        }

        emptyState.hidden = true;
        totalsWrapper.hidden = false;
        addToCartButton.disabled = false;

        variantIds.forEach(function (variantId) {
          const item = selectedProducts[variantId];
          const itemEl = document.createElement('div');

          itemEl.className = 'cd-order__selected-item';
          itemEl.dataset.variantId = variantId;

          const image = item.image
            ? '<img class="cd-order__selected-image" src="' +
              escapeHtml(item.image) +
              '" alt="' +
              escapeHtml(item.title) +
              '">'
            : '<div class="cd-order__selected-image"></div>';

          itemEl.innerHTML =
            image +
            '<div>' +
              '<p class="cd-order__selected-title">' +
                escapeHtml(item.title) +
              '</p>' +
              '<p class="cd-order__selected-price">' +
                formatMoney(item.price) +
              '</p>' +
              '<div class="cd-order__qty-row">' +
                '<button type="button" class="cd-order__qty-button" data-decrease aria-label="Disminuir cantidad">−</button>' +
                '<input class="cd-order__qty-input" data-qty-input aria-label="Cantidad" type="number" min="1" value="' +
                  item.quantity +
                '">' +
                '<button type="button" class="cd-order__qty-button" data-increase aria-label="Aumentar cantidad">+</button>' +
                '<button type="button" class="cd-order__remove" data-remove>Eliminar</button>' +
              '</div>' +
            '</div>';

          selectedProductsContainer.appendChild(itemEl);
        });

        updateTotals();
      }

      function switchTab(tabId) {
        section.querySelectorAll('[data-tab-button]').forEach(function (button) {
          const isActive = button.dataset.tabButton === tabId;

          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
          button.tabIndex = isActive ? 0 : -1;
        });

        section.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
          const isActive = panel.dataset.tabPanel === tabId;

          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });
      }

      section.addEventListener('keydown', function (event) {
        const current = event.target.closest('[data-tab-button]');

        if (
          !current ||
          !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)
        ) return;

        event.preventDefault();

        const tabs = [...section.querySelectorAll('[data-tab-button]')];
        let index = tabs.indexOf(current);

        if (event.key === 'Home') {
          index = 0;
        } else if (event.key === 'End') {
          index = tabs.length - 1;
        } else {
          index = (
            index +
            (event.key === 'ArrowRight' ? 1 : -1) +
            tabs.length
          ) % tabs.length;
        }

        switchTab(tabs[index].dataset.tabButton);
        tabs[index].focus();
      });

      let busy = false;

      section.addEventListener('click', function (event) {
        if (busy) return;

        const tabButton = event.target.closest('[data-tab-button]');
        const selectButton = event.target.closest('[data-select-product]');
        const increaseButton = event.target.closest('[data-increase]');
        const decreaseButton = event.target.closest('[data-decrease]');
        const removeButton = event.target.closest('[data-remove]');
        const showMoreButton = event.target.closest('[data-show-more]');

        if (tabButton) {
          switchTab(tabButton.dataset.tabButton);
        }

        if (showMoreButton) {
          const panel = showMoreButton.closest('[data-tab-panel]');

          if (panel) {
            panel
              .querySelectorAll('[data-product-card].is-hidden')
              .forEach(function (card) {
                card.classList.remove('is-hidden');
              });
          }

          showMoreButton.hidden = true;
        }

        if (selectButton) {
          const option = selectButton
            .closest('[data-product-card]')
            .querySelector('[data-variant-select]')?.selectedOptions[0];

          const variantId = option
            ? option.value
            : selectButton.dataset.variantId;

          if (selectButton.disabled || option?.disabled) return;

          if (!selectedProducts[variantId]) {
            selectedProducts[variantId] = {
              variantId: variantId,
              title: option
                ? option.dataset.title
                : selectButton.dataset.productTitle,
              price: Number(
                option
                  ? option.dataset.price
                  : selectButton.dataset.productPrice
              ),
              image: option
                ? option.dataset.image
                : selectButton.dataset.productImage,
              quantity: 1
            };
          } else {
            selectedProducts[variantId].quantity += 1;
          }

          renderSelectedProducts();
          setMessage(config.added_to_summary_text);
        }

        if (increaseButton || decreaseButton || removeButton) {
          const itemEl = event.target.closest('[data-variant-id]');
          if (!itemEl) return;

          const variantId = itemEl.dataset.variantId;
          const item = selectedProducts[variantId];

          if (!item) return;

          if (increaseButton) {
            item.quantity += 1;
          }

          if (decreaseButton) {
            item.quantity -= 1;

            if (item.quantity <= 0) {
              delete selectedProducts[variantId];
            }
          }

          if (removeButton) {
            delete selectedProducts[variantId];
          }

          renderSelectedProducts();
        }
      });

      section.addEventListener('change', function (event) {
        if (busy) return;

        const variantSelect = event.target.closest('[data-variant-select]');

        if (variantSelect) {
          const option = variantSelect.selectedOptions[0];

          variantSelect
            .closest('[data-product-card]')
            .querySelector('[data-card-price]')
            .textContent = formatMoney(option.dataset.price);

          return;
        }

        const qtyInput = event.target.closest('[data-qty-input]');
        if (!qtyInput) return;

        const itemEl = event.target.closest('[data-variant-id]');
        if (!itemEl) return;

        const variantId = itemEl.dataset.variantId;
        const nextQty = Math.max(
          1,
          parseInt(qtyInput.value, 10) || 1
        );

        if (selectedProducts[variantId]) {
          selectedProducts[variantId].quantity = nextQty;
        }

        renderSelectedProducts();
      });

      addToCartButton.addEventListener('click', function () {
        const items = Object.keys(selectedProducts).map(function (variantId) {
          return {
            id: Number(variantId),
            quantity: selectedProducts[variantId].quantity
          };
        });

        if (!items.length || busy) return;

        busy = true;
        addToCartButton.disabled = true;
        addToCartButton.textContent = config.loading_text;

        fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (error) {
                throw error;
              });
            }

            return response.json();
          })
          .then(async function () {
            setMessage(config.cart_success_text);

            if (config.redirect_to_cart) {
              window.location.href =
                (window.Shopify?.routes?.root || '/') + 'cart';
            } else {
              addToCartButton.textContent = config.cart_button_text;

              Object.keys(selectedProducts).forEach(function (id) {
                delete selectedProducts[id];
              });

              renderSelectedProducts();

              try {
                const { CartLinesUpdateEvent } =
                  await import('@shopify/events');

                const response = await fetch(
                  (window.Shopify?.routes?.root || '/') + 'cart.js'
                );

                if (!response.ok) throw new Error('cart');

                const cart = await response.json();

                section.dispatchEvent(new CartLinesUpdateEvent({
                  action: 'add',
                  context: 'product',
                  lines: items.map(function (item) {
                    return {
                      merchandiseId: String(item.id),
                      quantity: item.quantity
                    };
                  }),
                  promise: Promise.resolve({
                    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
                    detail: {
                      source: 'cosmic-calculator',
                      itemCount: cart.item_count,
                      items: cart.items
                    }
                  })
                }));
              } catch {
                window.location.href =
                  (window.Shopify?.routes?.root || '/') + 'cart';
              }
            }
          })
          .catch(function (error) {
            console.error(error);
            setMessage(config.cart_error_text);
            addToCartButton.disabled = false;
            addToCartButton.textContent = config.cart_button_text;
          })
          .finally(function () {
            busy = false;
          });
      });

      renderSelectedProducts();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
